import script from "./RegistrationCultureIndicators.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationCultureIndicators.vue?vue&type=script&setup=true&lang=ts"

import "./RegistrationCultureIndicators.vue?vue&type=style&index=0&id=7f1df6f7&lang=scss"

const __exports__ = script;

export default __exports__